import React from "react";
import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { useContent } from "../context/ContentContext";

export const WhatIf = () => {
  const { content } = useContent();
  const w = content.whatif;

  return (
    <section id="whatif" data-testid="whatif-section" className="relative py-12 md:py-14 bg-white border-y border-cream-2">
      <div className="mx-auto max-w-6xl px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-6 lg:gap-16 items-center">
          <div className="lg:col-span-6">
            <Reveal>
              <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl tracking-tight text-ink leading-[1.02]">
                {w.heading}<span className="text-ocean">…</span>
              </h2>
            </Reveal>

            <ul className="mt-6 space-y-3">
              {(w.items || []).map((item, i) => (
                <motion.li
                  key={i}
                  initial={{ opacity: 0, x: -16 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.6, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
                  className="flex items-baseline gap-3 text-base md:text-lg"
                >
                  <span className="h-1.5 w-1.5 rounded-full bg-peach shrink-0 translate-y-[-3px]" />
                  <span className="text-ink-muted">
                    {item.from} <span className="text-ink font-medium">{item.to}?</span>
                  </span>
                </motion.li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-6">
            <Reveal delay={0.12}>
              <div className="lg:pl-8 lg:border-l border-sand">
                <p className="text-base md:text-lg text-ink-soft leading-relaxed">{w.body1}</p>
                <p className="mt-4 text-base md:text-lg text-ink-soft leading-relaxed">{w.body2}</p>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatIf;
